var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 24,
    viewBox: "0 0 20.001 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(-42.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(42.657 3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M62.587,91.41l-1.718-2.862a8.507,8.507,0,0,1-1.211-4.374V81.667a7,7,0,1,0-14,0v2.507a8.507,8.507,0,0,1-1.211,4.374L42.729,91.41a.5.5,0,0,0,.429.757h19a.5.5,0,0,0,.429-.757Zm-18.546-.243L45.3,89.062a9.5,9.5,0,0,0,1.354-4.888V81.667a6,6,0,1,1,12,0v2.507a9.507,9.507,0,0,0,1.353,4.888l1.264,2.105Z",
    transform: "translate(-42.657 -74.667)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(50.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M215.333,0a2,2,0,0,0-2,2V4a.5.5,0,0,0,1,0V2a1,1,0,0,1,2,0V4a.5.5,0,0,0,1,0V2A2,2,0,0,0,215.333,0Z",
    transform: "translate(-213.333)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(50.158 20.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M207.33,426.926a.5.5,0,1,0-.864.506,1.5,1.5,0,1,1-2.6,0,.5.5,0,1,0-.864-.506,2.5,2.5,0,1,0,4.326,0Z",
    transform: "translate(-202.666 -426.68)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.7d8a267a.svg";
export { ForwardRef as ReactComponent };